export const getCurrency = state => {
  return state.currency
}



// WEBPACK FOOTER //
// ./src/store/modules/properties/getters.js